import React from 'react';
import moment from 'moment';
import { Image } from 'semantic-ui-react';

import history from '../../history';
import { getStatusTitle, getStatusText } from '../../utils/status';

const StakeTile = ({stake, user}) => {
  const { isMyStake, title, lastUpdated, status, stakeeProfile, stakerProfile, amount, currency } = stake;

  const opponent = isMyStake ? stakeeProfile : stakerProfile;

  const statusTitle = getStatusTitle(stake, status, user);

  let updated = moment(lastUpdated).fromNow();

  if (updated === 'a few seconds ago')
    updated = 'seconds ago';
  
  return (
    <div className="stake-tile" onClick={() => history.push(`/stakes/${stake.id}`)}>
      <div className="stake-title">
        <div>{title}</div>
        <span className="sub">{updated}</span>
      </div>

      <div className={`status-banner ${statusTitle.replace(' ', '')}`}>
        {statusTitle.toUpperCase()}
        <div className="sub">{getStatusText(stake, opponent.name, user)}</div>
      </div>

      <div className="stakee">
        <Image avatar src={opponent.avatar} /> @{opponent.name}
        <span className="amount">{amount} {currency}</span>
      </div>
    </div>
  );
};

export default StakeTile;



// WEBPACK FOOTER //
// ./src/App/Home/StakeTile.js